import { gql } from "@apollo/client";

export const MeetingHeaderFragment = gql`
  fragment MeetingHeaderFragment on MeetingNode {
    id
    title
    startDatetime
    meetingGroupId
    draft
    isRecurring
  }
`;

export default gql`
  ${MeetingHeaderFragment}
  query getPreviousMeetingsQuery(
    $meetingGroupId: Int!
    $beforeDate: DateTime!
    $maxFutureDate: DateTime!
    $after: String
    $limit: Int!
  ) {
    meetings(
      meetingGroupId: $meetingGroupId
      startDatetime_Lte: $beforeDate
      first: $limit
      after: $after
      orderBy: "-start_datetime"
      draft: false
      ignored: false
    ) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          ...MeetingHeaderFragment
        }
      }
    }
    nextMeetings: meetings(
      meetingGroupId: $meetingGroupId
      startDatetime_Gte: $beforeDate
      startDatetime_Lte: $maxFutureDate
      first: 65
      orderBy: "start_datetime"
      draft: false
      ignored: false
    ) {
      edges {
        node {
          ...MeetingHeaderFragment
        }
      }
    }
  }
`;
